import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useHistory } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { fetchData, postData, SyncData, updateData, deleteData, TripCustomerfetchData } from '../../../apiService';
import { Card, CardContent, IconButton, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import Button from '@mui/material/Button';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Select from 'react-select';
import Paper from '@mui/material/Paper';
import { Tooltip } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import DeleteIcon from '@mui/icons-material/Delete';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Link } from 'react-router-dom';
import { ThreeDRotationOutlined } from '@mui/icons-material';
import { Discount } from '@mui/icons-material';
import { FaHtml5, FaWeight } from 'react-icons/fa';
import Modal from '@mui/material/Modal';
import { FaTimes } from 'react-icons/fa'; // Example for FontAwesome Icon
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios'; // Make sure axios is installed and imported
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CircularProgress from '@mui/material/CircularProgress';


const AdditionalOrderEdit = () => {
    const { id } = useParams();

    const history = useHistory();
    const { isAuthenticated, companyId, userId, permissions, token, logout } = useAuth();

    // State to control the visibility of the container
    const [isContainerVisible, setIsContainerVisible] = useState(false);

    const toggleContainerVisibility = () => setIsContainerVisible(!isContainerVisible);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [quantity, setQuantity] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [totalQuantity, setTotalQuantity] = useState(0);
    const [customerName, setCustomerName] = useState('');
    const [rate, setRate] = useState('');
    const [discount, setDiscount] = useState(''); // Correct 
    const [singlediscount, setsingleDiscount] = useState(''); // Correct capitalization
    const [gstRate, setGSTRate] = useState('');
    const [paymentMode, setPaymentMode] = useState('');
    const [tripdate, setTripdate] = useState('');
    const [customerId, setCustomerId] = useState('');
    const [qty, setQty] = useState('');
    const [discountPerPiece, setDiscountPerPiece] = useState('');
    const [loading, setLoading] = useState(false);
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [Remarks, setRemarks] = useState("");

    const [items, setitems] = useState('');
    const [isReturnsale, setisReturn] = useState('');
    const [bundle, setBundle] = useState(null);
    const [Bundle, setbundle] = useState(null);
    const [pieces, setPieces] = useState('');
    const [LastBillDate, setLastBillDate] = useState("");
    const [LastBillAmount, setLastBillAmount] = useState("");
    const [Outstanding, setOutstanding] = useState("");
    const [pricetype, setpricetype] = useState('');
    const [categoryId, setCategoryId] = useState('');
    const [productCategoryId, setPCategoryId] = useState('');
    const [itemId, setItemId] = useState('');
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [pcategoryOptions, setPCategoryOptions] = useState([]);
    const [itemOptions, setItemOptions] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedPCategory, setSelectedPCategory] = useState(null);
    const [selectedItem, setSelectedItem] = useState(null);
    const [itemnameget, setItemName] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [selecteditems, setSelectedItems] = useState("");
    const [itemsOptions, setItemsrOptions] = useState([]);
    const [selectedItemsType, setSelectedItemsType] = useState("");
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [formData, setFormData] = useState([]);
    const [itemdata, setData] = useState([]);
    const [tripId, setTripId] = useState("");
    const [QtyBundle, setQtyBundle] = useState('');
    const [Route, setRoute] = useState([]);
    const [orderDate, setOrderDate] = useState('');
    const [invoice, setInvoice] = useState('');
    const [TripWiseID, setTripWiseID] = useState('');
    const [routeId, setrouteId] = useState('');
    const [SaleRemarks, setsaleRemarks] = useState('');
    const [CustName, setCustName] = useState('');
    const[addressLine1, setaddressLine1]=useState('');
    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        fetchItemData();
    }, [isAuthenticated, companyId, token, logout]);


    // Add a function to format the date
    const formatDateForInput = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        let month = (date.getMonth() + 1).toString();
        let day = date.getDate().toString();

        // Pad the month and day with leading zeros if needed
        month = month.length === 1 ? `0${month}` : month;
        day = day.length === 1 ? `0${day}` : day;

        return `${year}-${month}-${day}`;
    };
    
    const formatTimeForInput = (timeString) => {
        const time = new Date(`1970-01-01T${timeString}`);
        const hours = time.getHours().toString().padStart(2, '0');
        const minutes = time.getMinutes().toString().padStart(2, '0');
        const seconds = time.getSeconds().toString().padStart(2, '0');

        return `${hours}:${minutes}:${seconds}`;
    };

    const hasCreateTransactionPermission = permissions.includes('Create Transaction');
    const hasEditTransactionPermission = permissions.includes('Edit Transaction');
    const hasDeleteTransactionPermission = permissions.includes('Delete Transaction');

    useEffect(() => {

        fetchData('AdditionalOrderEditAPI', `/${id}`, token)
            .then((response) => {
                
                const array = response.response_data.saleOrder;

                if (response.responseCode === '1111') {
                    setFormData(response.response_data.saleOrder);
                    setCustomerId(response.response_data.saleOrder.customerId);
                    setData(response.response_data.saleOrderDetails);
                    setrouteId(response.response_data.saleOrder.routeId);
                    setItemList(response.response_data.saleOrderDetails.map(item => ({ ...item, IsActive: true })));
                    setCustomerName(response.response_data.SaleOrder.customerName);
                    setaddressLine1(response.response_data.SaleOrder.addressLine1)
                    setsaleRemarks(response.response_data.saleOrder.saleRemarks);
                    setTripId(response.response_data.saleOrder.tripId);
                    setTripWiseID(response.response_data.saleOrder.tripId);
                    setRoute(array.route);
                    setOrderDate(response.response_data.saleOrder.orderDate);
                    console.log(response.response_data.saleOrderDetails);

                }
                setFormData((prevData) => ({
                    ...prevData,
                    ModifiedBy: userId,
                }));
            })
            .catch((error) => {
                console.error('Error fetching Sale Details:', error);
            });
    }, [id]);


    const handleSubmit = (event) => {
        event.preventDefault();
        setFormData(prevData => ({
            ...prevData,
            ModifiedBy: userId,
        }));
        const CreateData = {
            SaleOrder: formData,
            SaleOrderDetails: itemdata
        };
        updateData('SaleApi', `${id}`, CreateData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push(`/AddtionalOrderIndex/${tripId}`);
            })
            .catch((error) => {
                console.error('Error updating record:', error);
            });
    };

    const removeRecord = (index) => {
        openConfirmDialog(index);
    };

    //Items
    const fetchItems = async () => {
        try {
            const response = await fetchData('DespatchReport', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(item => ({
                    value: item.Id,
                    label: item.Name
                }));
                setItemsrOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };
    const handleItemsChange = (selectedOption) => {
        setSelectedItemsType(selectedOption);
    };

    useEffect(() => {
        fetchItems();
    }, []);

    const [isModalOpen, setIsModalOpen] = useState(false);

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };


    const fetchItemData = async () => {
        try {
            setLoading(true);
            const response = await fetchData('AdditionalOrderEditAPI', `/${id}`, token);
            if (response.responseCode === '1111') {
                setFormData(response.response_data.saleOrder);
                setCustomerId(response.response_data.saleOrder.customerId);
                setCustomerName(response.response_data.saleOrder.customerName);
                setsaleRemarks(response.response_data.saleOrder.saleRemarks);
                setData(response.response_data.saleOrderDetails);
                setItemList(response.response_data.saleOrderDetails.map(item => ({ ...item, IsActive: true })));
                setrouteId(response.response_data.saleOrder.routeId);
                setOrderDate(response.response_data.saleOrder.orderDate);
                const tripid = response.response_data.saleOrder.tripId;
                setTripId(tripid);
                console.log(tripid);
            }
        } catch (error) {
            console.error('Error fetching Item', error);
        } finally {
            setLoading(false);
        }
    };



    //Product catgory
    useEffect(() => {
        const fetchPCategoryTypes = async () => {
            try {
                const response = await fetchData('ProductCategoryApi', `/${companyId}`, token);
                if (response.responseCode === '1111') {
                    const dataArray = response.response_data;
                    const options = response.response_data.map(pcat => ({
                        value: pcat.id,
                        label: pcat.name
                    }));
                    setPCategoryOptions(options);
                    setPCategoryId(dataArray[0].id);
                }
            } catch (error) {
                console.error('Error fetching categories:', error);
            }
        };
        fetchPCategoryTypes();
    }, [companyId, token]);

    const handlePCategoryChange = (selectedOption) => {

        setSelectedPCategory(selectedOption);
        fetchCategoryTypes(selectedOption.value);
        setPCategoryId(selectedOption.value);
        setSelectedItem(null);
        setSelectedCategory(null);

    };

    //varient
    const fetchCategoryTypes = async (productCategoryId) => {
        try {
            const response = await fetchData('CategoryApi', `/${companyId}/${productCategoryId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(cat => ({
                    value: cat.id,
                    label: cat.name
                }));
                setCategoryOptions(options);
            }
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    };


    const handleCategoryChange = (selectedOption) => {
        setSelectedCategory(selectedOption);
        fetchItemsTypes(selectedOption.value);
        setCategoryId(selectedOption.value);
        setSelectedItem(null);
    };

    const fetchItemsTypes = async (categoryId) => {
        try {
            const response = await fetchData('ItemApi', `/${companyId}/${categoryId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(item => ({
                    value: item.id,
                    label: item.name
                }));
                setItemOptions(options);
            }
        } catch (error) {
            console.error('Error fetching items:', error);
        }
    };


    const handleItemChange = async (selectedOptions) => {
        setSelectedItem(selectedOptions);
        const ItemID = selectedOptions.value;
        setItemId(ItemID);

        try {
            const response = await fetchData('RoutePriceTypeApi', `/${routeId}/${ItemID}`, token);

            if (response && response.response_data && response.response_data.length > 0) {
                let itemFound = false;

                // Iterate through each category in response_data
                response.response_data.forEach(category => {
                    if (category.Items && category.Items.length > 0) {
                        category.Items.forEach(item => {
                            if (!itemFound) {
                                console.log(`Processing item: ${item.Name}`);
                                // Process each item here
                                // Extract numeric part from Weight

                                const { Rate, GSTRate, Weight, bundle, QtyBundle } = item;
                                const numericWeight = parseFloat(Weight);
                                setRate(Rate);
                                setGSTRate(GSTRate);
                                setBundle(bundle);
                                setQtyBundle(QtyBundle);
                                setNewItem((prevItem) => ({
                                    ...prevItem,
                                    weight: numericWeight, // Add weight to the newItem state
                                    rate: Rate,
                                    gstRate: GSTRate,
                                    //Bundle: Bundle,
                                    bundle: bundle ?? 0, // Set Bundle to 0 if it's null
                                    QtyBundle: QtyBundle ?? 0,
                                }));
                                itemFound = true; // Set itemFound to true when an item is processed
                            }
                        });
                    }
                });

                if (!itemFound) {
                    console.error('No items found in the response data');
                }
            } else {
                console.error('Invalid response structure');
            }
        } catch (error) {
            console.error('Error fetching item rate:', error);
        }
    };

    const [newItem, setNewItem] = useState("");



    useEffect(() => {
        const Quantity = parseInt(qty) || 0;
        const gstAmount = (rate * gstRate) / 100;
        const totalAmount = rate * Quantity;
        const totalPlusGst = totalAmount + gstAmount;
        //const bundle = bundle;

        setNewItem((prevItem) => ({
            ...prevItem,
            Rate: rate,
            totalAmount: totalAmount,
            gstAmount: gstAmount,
            totalPlusGst: totalPlusGst,
            discount: discount, // Ensure correct reference
            bundle: bundle,
            //pieces: pieceCount,
        }));
    }, [rate, qty, discount, gstRate, bundle]); // Added dependencies

    const [itemList, setItemList] = useState([]);


    //dulicate check - compare both ItemId and itemId (API returns itemId lowercase)
    const isDuplicateItem = (itemList, newItem) => {
        return itemList.some(item => {
            const existingId = item.ItemId ?? item.itemId;
            return existingId === newItem.ItemId;
        });
    };


    const AddtoListdata = (e) => {
        e.preventDefault();
        if (qty > 0) {
            const quantity = parseInt(qty);
            const discountPerPiece = newItem.discountPerPiece || 0; // Default to 0 if DiscountPerPiece is null or undefined
            const discount = parseInt(discountPerPiece) || 0;
            const bundleSize = parseInt(newItem.QtyBundle) || 0; // Default to 1 if Bundle is null or 0
            const numBundles = bundleSize ? Math.floor(quantity / bundleSize) : 0;
            const pieceCount = bundleSize ? quantity % bundleSize : 0;
            const ratePerKg = rate;
            const isdelete = true;
            const gstRate = newItem.gstRate || 0;

            let RateAfterDiscount = 0;

            if (discount > 0) {
                RateAfterDiscount = ratePerKg - discount;
            }
            else {
                RateAfterDiscount = rate;
            }
            const totalQty = newItem.weight * quantity;
            const totalAmount = ratePerKg * quantity;
            const TotalAmtperkgwise = ratePerKg * totalQty;
            const taxableAmt = ((RateAfterDiscount) * totalQty * 100) / (100 + gstRate);
            const gstAmt = (taxableAmt * gstRate) / 100;
            const GstPer = (gstAmt / taxableAmt) * 100;
            const netAmt = taxableAmt + gstAmt;

            const updatedItem = {
                ...newItem,
                item: selectedItem.label,
                ItemId: selectedItem.value,
                quantity: quantity,
                rate: rate,
                RateAfterDiscount: RateAfterDiscount,
                gstRate: gstRate,
                totalAmount: totalAmount,
                netAmt: netAmt,
                discount: discount,
                totalQty: totalQty,
                ratePerKg: ratePerKg,
                TotalAmtperkgwise: TotalAmtperkgwise,
                taxableAmt: taxableAmt,
                gstAmt: gstAmt,
                gstPer: GstPer,
                bundle: numBundles,
                pieces: pieceCount,
                Isdelete: isdelete,
                QtyBundle: QtyBundle,
            };
            // Check for duplicates
            if (isDuplicateItem(itemList, updatedItem)) {
                alert("This Item already exists in the list.");
                return;
            }

            // Updating state
            setItemList([...itemList, updatedItem]);

            // Resetting newItem state
            setNewItem({
                ItemId: '',
                Name: '',
                quantity: 1,
                gstRate: 0,
                rate: 0,
                totalAmount: 0,
                totalPlusGst: 0,
                discount: 0,
                weight: 0,
                totalQty: 0,
                ratePerKg: 0,
                TotalAmtperkgwise: 0,
                GstPer: 0,
                gstAmt: 0,
                taxableAmt: 0,
                bundle: 0,
                pieces: 0,
                RateAfterDiscount: 0,
                Isdelete: 0,
                selectedPCategory,
                selectedCategory,
                selectedItem,
            });

            // Resetting other state variables
            setSelectedItem('');
            setQty('');
            setRate('');
            setGSTRate(0);
            setBundle('');
        }
    };
    const handleChange = event => {
        const { name, value } = event.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };


    const handleQuantityChange = (e, index) => {
        const { value } = e.target;
        const updatedItems = [...itemList];
        updatedItems[index].quantity = parseInt(value, 10);
        let bundleSize = 0;// Default to 1 if Bundle is null or 0

        const discountPerPiece = updatedItems[index].discountPerPiece || 0;
        const bag = updatedItems[index].bagWeight || 0;
        const bagweight = updatedItems[index].weight || 0;
        let BagWeight = 0;
        if (bag > 0) { //exixting
            BagWeight = bag;
            // bundleSize = parseInt(updatedItems[index].BundleAndPiece) || 0;
            bundleSize = parseInt(updatedItems[index].bundleAndPiece) || 0;
        }
        else if (bagweight > 0) {
            BagWeight = bagweight;
            bundleSize = parseInt(updatedItems[index].QtyBundle) || 0;

        }
        const numBundles = bundleSize ? Math.floor(value / bundleSize) : 0;
        const pieceCount = bundleSize ? value % bundleSize : 0;
        const totalQty = BagWeight * value;
        const ratePerKg = updatedItems[index].ratePerKg;
        const RateAfterDiscount = ratePerKg - discountPerPiece;
        const totalAmount = updatedItems[index].rate * updatedItems[index].quantity;
        const TotalAmtperkgwise = RateAfterDiscount * totalQty;
        const taxableAmt = (((RateAfterDiscount) * totalQty * 100) / (100 + updatedItems[index].gstRate));
        // const gstAmount = (totalAmount * updatedItems[index].GSTRate) / 100;
        const gstAmt = (taxableAmt * updatedItems[index].gstRate) / 100;
        const gstRate = updatedItems[index].gstRate;
        const GstPer = (gstAmt / taxableAmt) * 100;
        const netAmt = taxableAmt + gstAmt;
        updatedItems[index].RateAfterDiscount = RateAfterDiscount;
        updatedItems[index].gstAmt = gstAmt;
        updatedItems[index].netAmt = netAmt;
        updatedItems[index].discountPerPiece = discountPerPiece;
        updatedItems[index].totalQty = totalQty;
        updatedItems[index].gstRate = gstRate;
        updatedItems[index].taxableAmt = taxableAmt;
        updatedItems[index].bundle = numBundles;
        updatedItems[index].pieces = pieceCount;
        setItemList(updatedItems);
    };

    const handleDiscountChange = (e, index) => {
        const value = parseFloat(e.target.value) || 0;
        const updatedItems = [...itemList];
        updatedItems[index].discountPerPiece = value;
        const totalQty = updatedItems[index].totalQty;

        const rateperkg = updatedItems[index].ratePerKg;
        const RateAfterDiscount = rateperkg - updatedItems[index].discountPerPiece;
        const totalAmount = updatedItems[index].rate * updatedItems[index].quantity;
        const TotalAmtperkgwise = RateAfterDiscount * totalQty;
        const taxableAmt = (((RateAfterDiscount) * totalQty * 100) / (100 + updatedItems[index].gstRate));
        // const gstAmount = (totalAmount * updatedItems[index].GSTRate) / 100;
        const gstAmt = (taxableAmt * updatedItems[index].gstRate) / 100;
        const gstRate = updatedItems[index].gstRate;
        const GstPer = (gstAmt / taxableAmt) * 100;
        const netAmt = taxableAmt + gstAmt;
        updatedItems[index].RateAfterDiscount = RateAfterDiscount;
        updatedItems[index].gstAmt = gstAmt;
        updatedItems[index].netAmt = netAmt;
        updatedItems[index].discount = value;
        updatedItems[index].gstRate = gstRate;
        updatedItems[index].taxableAmt = taxableAmt;
        setItemList(updatedItems);
    };


    const handleQtyChange = (e) => {
        const input = e.target.value.replace(/\D/g, '');
        if (input.length <= 10) {
            setQty(input); // Update state with cleaned input

            const quantity = parseInt(input) || 0;

            const gstAmount = (rate * gstRate) / 100;
            const totalAmount = rate * quantity;
            const totalPlusGst = totalAmount + gstAmount;
            const totalQty = newItem.weight * quantity;

            // Update state with the new calculated values
            setNewItem((prevItem) => ({
                ...prevItem,
                quantity: quantity,
                totalAmount: totalAmount,
                gstRate: gstRate,
                gstAmount: gstAmount,
                totalPlusGst: totalPlusGst,

                discount: discount,
                totalQty: totalQty,
            }));
        }
    };
    const addRecord = async (e) => {
        e.preventDefault();
        let isValid = true;

        itemList.forEach((item) => {
            if (!item.quantity || item.quantity <= 0) {
                isValid = false;
            }
        });

        if (!isValid) {
            alert('Please Enter Quantity❗');
            setIsLoading(false);
            return;
        }


        const itemsToSave = itemList.map(item => ({
            Id: item.id ?? item.Id ?? 0,
            ItemId: item.ItemId ? item.ItemId : (item.itemId ? item.itemId : null),
            CustomerId: customerId,
            CompanyId: companyId,
            CategoryId: categoryId,
            ProductCategoryId: item.productCateogryId ? item.productCateogryId : (item.ProductCategoryId ? item.ProductCategoryId : null),
            Rate: item._ratePerKgNum ?? parseFloat(item.ratePerKg) ?? item.rate ?? 0,
            Quantity: item.quantity,
            Discount: item.discount ? item.discount : 0,
            BilledDate: new Date(),
            CreatedBy: userId,
            CreatedDate: new Date(),
            RatePerKg: item._ratePerKgNum ?? parseFloat(item.ratePerKg) ?? item.ratePerKg ?? 0,
            DiscountPerPiece: item.discountPerPiece ? item.discountPerPiece : 0,
            TotalQty: item.totalQty,
            BagWeight: item.bagWeight || item.weight,
            CGSTAmt: (item.gstAmt / 2),
            SGSTAmt: (item.gstAmt / 2),
            GSTAmt: item.gstAmt,
            TaxableAmt: item.taxableAmt,
            NetAmt: item.netAmt,
            Bundle: item.bundle,
            Pieces: item.pieces,
            IsActive: item.IsActive === false ? false : true,
        }));

        const saleorderdata = {

            CustomerId: customerId,
            Id: id,
            SaleRemarks: SaleRemarks,
            OrderType: 1,
            CreatedBy: userId,
            CompanyId: companyId,
            RouteId: routeId,
            CreatedDate: new Date(),
        };

        const updateRecord = {
            SaleOrder: saleorderdata,
            SaleOrderDetails: itemsToSave,
        };

        try {
            const response = await updateData('AdditionalOrderEditAPI', id, updateRecord, token);
            console.log('Record updated successfully:', response);

            setTimeout(() => {
                setSuccessMessage("");
            }, 3000);
            setQuantity("");
            setSelectedItemsType("");

            fetchItemData();
            history.push(`/AddtionalOrderIndex/${tripId}`);


            setIsModalOpen(true);
        } catch (error) {
            console.error('Error updating record:', error);
        }

    };
    const [itemToDeleteIndex, setItemToDeleteIndex] = useState(null);
    const [itemName, setItemNames] = useState('');

    const openConfirmDialog = (index) => {
        setItemToDeleteIndex(index);
        setDeleteItemId(null);
        setItemNames('');
        setConfirmDialogOpen(true);
    };

    const ConfirmDialog = (index, deleteItemId, itemName = '') => {
        setItemToDeleteIndex(null);
        setDeleteItemId(deleteItemId);
        setItemNames(itemName);
        setConfirmDialogOpen(true);
    };


    const closeConfirmDialog = () => {
        setConfirmDialogOpen(false);
        setItemToDeleteIndex(null);
        setDeleteItemId(null);
        setItemNames('');
    };

    const handleDelete = () => {
        if (itemToDeleteIndex !== null) {
            const item = itemList[itemToDeleteIndex];
            const savedId = item.id ?? item.Id ?? null;

            if (savedId) {
                // Saved item — mark IsActive false, keep in list for payload, hide from UI
                const updatedItemList = itemList.map((it, i) =>
                    i === itemToDeleteIndex ? { ...it, IsActive: false } : it
                );
                setItemList(updatedItemList);
            } else {
                // Newly added item (no id) — just remove from list
                const updatedItemList = itemList.filter((_, i) => i !== itemToDeleteIndex);
                setItemList(updatedItemList);
            }
            closeConfirmDialog();
        } else {
            closeConfirmDialog();
        }
    };

    const handleRateChange = (e, index) => {
        const rawValue = e.target.value;
        const newRate = rawValue === '' ? '' : rawValue;  // keep raw string while typing

        setItemList((prevItemList) => {
            return prevItemList.map((item, i) => {
                if (i === index) {
                    const numericRate = parseFloat(rawValue) || 0;
                    const quantity = item.quantity;
                    const bag = item.bagWeight || 0;
                    const bagweight = item.weight || 0;
                    const BagWeight = bag > 0 ? bag : bagweight;
                    const totalQty = BagWeight * quantity;
                    const discountPerPiece = item.discountPerPiece || 0;
                    const RateAfterDiscount = numericRate - discountPerPiece;
                    const taxableAmt = (RateAfterDiscount * totalQty * 100) / (100 + (item.gstRate || 0));
                    const gstAmt = (taxableAmt * (item.gstRate || 0)) / 100;
                    const netAmt = taxableAmt + gstAmt;

                    return {
                        ...item,
                        ratePerKg: newRate,          // keep raw string so input stays editable
                        _ratePerKgNum: numericRate,  // numeric value used for calculations & payload
                        RateAfterDiscount,
                        totalQty,
                        taxableAmt,
                        gstAmt,
                        netAmt,
                    };
                }
                return item;
            });
        });
    };

    return (
        <div style={{ maxWidth: '100%', backgroundColor: '#f3edf8', padding: '12px' }}>
            <div style={{ backgroundColor: 'white', borderRadius: '10px', boxShadow: '0 2px 12px rgba(107,76,122,0.10)', overflow: 'hidden' }}>
                {loading && (
                    <div style={{
                        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
                        backgroundColor: 'rgba(107, 76, 122, 0.18)', backdropFilter: 'blur(3px)',
                        display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
                    }}>
                        <div style={{
                            display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px',
                            backgroundColor: 'white', borderRadius: '12px', padding: '24px 40px',
                            boxShadow: '0 8px 32px rgba(107,76,122,0.18)'
                        }}>
                            <CircularProgress style={{ color: '#6b4c7a' }} size={36} thickness={4} />
                            <span style={{ color: '#6b4c7a', fontSize: '13px', fontWeight: 600 }}>Loading...</span>
                        </div>
                    </div>
                )}
                <form onSubmit={addRecord}>

                    {/* ── Header Bar ── */}
                    <div style={{
                        background: 'linear-gradient(135deg, #6b4c7a 0%, #9b6dac 100%)',
                        padding: '10px 16px',
                        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                    }}>
                        <div>
                            <h2 style={{ margin: 0, fontSize: '14px', fontWeight: 700, color: 'white', letterSpacing: '0.8px', textTransform: 'uppercase' }}>
                                ✏️ Additional Order Edit
                            </h2>
                            <div style={{ marginTop: '2px', fontSize: '11px', color: 'rgba(255,255,255,0.8)' }}>
                                Order Date: <strong style={{ color: 'white' }}>{orderDate && new Date(orderDate).toLocaleDateString('en-GB')}</strong>
                            </div>
                        </div>
                        <div style={{ display: 'flex', gap: '8px' }}>
                            <Button variant="contained" type="submit" style={{
                                height: '32px', fontSize: '11px', fontWeight: 700,
                                backgroundColor: '#10a37f', color: 'white',
                                borderRadius: '16px', textTransform: 'none',
                                boxShadow: '0 2px 6px rgba(16,163,127,0.4)',
                                padding: '0 14px',
                            }}>
                                ✓ Update Order
                            </Button>
                            <Tooltip title="Back To List">
                                <Link to={`/AddtionalOrderIndex/${tripId}`} style={{ textDecoration: 'none' }}>
                                    <Button variant="contained" style={{
                                        height: '32px', fontSize: '11px', fontWeight: 700,
                                        backgroundColor: 'rgba(255,255,255,0.15)', color: 'white',
                                        borderRadius: '16px', textTransform: 'none',
                                        border: '1px solid rgba(255,255,255,0.4)', boxShadow: 'none',
                                        padding: '0 12px',
                                    }}>
                                        Back <ExitToAppIcon style={{ marginLeft: '3px', fontSize: '14px' }} />
                                    </Button>
                                </Link>
                            </Tooltip>
                        </div>
                    </div>

                    <div style={{ padding: '10px 14px' }}>

                        {/* ── Customer / Remarks / Add Item — all in one compact row ── */}
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr',
                            gap: '8px',
                            marginBottom: '8px',
                            padding: '10px 12px',
                            backgroundColor: '#faf8fc',
                            borderRadius: '8px',
                            border: '1px solid #e8dff0',
                        }}>
                            <div>
                                <label style={{ display: 'block', fontSize: '10px', fontWeight: 700, color: '#6b4c7a', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.4px' }}>
                                    👤 Customer
                                </label>
                                <input
                                    value={`${customerName} ${addressLine1}`}
                                    type="text" disabled
                                    style={{
                                        width: '100%', height: '32px', padding: '0 10px',
                                        fontSize: '12px', fontWeight: 600,
                                        border: '1px solid #e0d4ec', borderRadius: '6px',
                                        backgroundColor: '#f0e8f5', color: '#4a2d5a',
                                        boxSizing: 'border-box',
                                    }}
                                />
                            </div>
                            <div>
                                <label style={{ display: 'block', fontSize: '10px', fontWeight: 700, color: '#6b4c7a', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.4px' }}>
                                    📝 Remarks
                                </label>
                                <input
                                    name="SaleRemarks" value={SaleRemarks}
                                    onChange={e => setsaleRemarks(e.target.value)}
                                    type="text" placeholder="Enter remark..." maxLength="100" autoComplete="off"
                                    style={{
                                        width: '100%', height: '32px', padding: '0 10px',
                                        fontSize: '12px', border: '1.5px solid #e0d4ec',
                                        borderRadius: '6px', outline: 'none',
                                        transition: 'border-color 0.2s', boxSizing: 'border-box',
                                    }}
                                    onFocus={e => e.target.style.borderColor = '#6b4c7a'}
                                    onBlur={e => e.target.style.borderColor = '#e0d4ec'}
                                />
                            </div>
                        </div>

                        {/* ── Add Item Section ── */}
                        <div style={{
                            padding: '10px 12px',
                            backgroundColor: '#faf8fc',
                            borderRadius: '8px',
                            border: '1px solid #e8dff0',
                            marginBottom: '10px',
                        }}>
                            <div style={{ fontSize: '10px', fontWeight: 700, color: '#6b4c7a', textTransform: 'uppercase', letterSpacing: '0.4px', marginBottom: '8px' }}>
                                ➕ Add Item
                            </div>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 110px auto', gap: '8px', alignItems: 'flex-end' }}>

                                {/* shared Select style */}
                                {[
                                    { label: 'Category', value: selectedPCategory, onChange: handlePCategoryChange, options: pcategoryOptions, placeholder: 'Select Category' },
                                    { label: 'Variant', value: selectedCategory, onChange: handleCategoryChange, options: categoryOptions, placeholder: 'Select Variant' },
                                    { label: 'Variant with Bagweight', value: selectedItem, onChange: handleItemChange, options: itemOptions, placeholder: 'Select Item' },
                                ].map((sel, i) => (
                                    <div key={i}>
                                        <label style={{ display: 'block', fontSize: '10px', fontWeight: 600, color: '#555', marginBottom: '4px' }}>{sel.label}</label>
                                        <Select
                                            value={sel.value}
                                            onChange={sel.onChange}
                                            options={sel.options}
                                            placeholder={sel.placeholder}
                                            isSearchable
                                            menuPortalTarget={document.body}
                                            styles={{
                                                control: (base, state) => ({
                                                    ...base, fontSize: '12px', minHeight: '32px', height: '32px',
                                                    borderColor: state.isFocused ? '#6b4c7a' : '#e0d4ec',
                                                    borderRadius: '6px',
                                                    boxShadow: state.isFocused ? '0 0 0 2px rgba(107,76,122,0.12)' : 'none',
                                                    '&:hover': { borderColor: '#6b4c7a' },
                                                }),
                                                valueContainer: (base) => ({ ...base, padding: '0 8px' }),
                                                indicatorsContainer: (base) => ({ ...base, height: '32px' }),
                                                option: (base, state) => ({
                                                    ...base, fontSize: '12px', padding: '6px 10px',
                                                    backgroundColor: state.isSelected ? '#6b4c7a' : state.isFocused ? '#f3edf8' : 'white',
                                                }),
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            }}
                                        />
                                    </div>
                                ))}

                                <div>
                                    <label style={{ display: 'block', fontSize: '10px', fontWeight: 600, color: '#555', marginBottom: '4px' }}>QTY (Pieces)</label>
                                    <input
                                        value={qty} onChange={handleQtyChange} type="text" placeholder="0"
                                        style={{
                                            width: '100%', height: '32px', padding: '0 10px',
                                            fontSize: '12px', fontWeight: 600,
                                            border: '1.5px solid #e0d4ec', borderRadius: '6px',
                                            textAlign: 'center', outline: 'none', boxSizing: 'border-box',
                                            transition: 'border-color 0.2s',
                                        }}
                                        onFocus={e => e.target.style.borderColor = '#6b4c7a'}
                                        onBlur={e => e.target.style.borderColor = '#e0d4ec'}
                                    />
                                </div>
                                <div>
                                    <Button variant="contained" onClick={AddtoListdata} style={{
                                        height: '32px', fontSize: '11px', fontWeight: 700,
                                        backgroundColor: '#6b4c7a', color: 'white',
                                        borderRadius: '6px', textTransform: 'none',
                                        whiteSpace: 'nowrap', padding: '0 14px',
                                        boxShadow: '0 2px 6px rgba(107,76,122,0.3)',
                                    }}>
                                        + Add
                                    </Button>
                                </div>
                            </div>
                        </div>
                    <div style={{ marginTop: '8px', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 2px 10px rgba(107,76,122,0.12)', border: '1px solid #e0d6e8' }}>
                        <div style={{ overflowX: 'auto', maxHeight: '420px', overflowY: 'auto' }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
                                <colgroup>
                                    <col style={{ width: '14%' }} />  {/* Name */}
                                    <col style={{ width: '7%' }} />   {/* Qty */}
                                    <col style={{ width: '7%' }} />   {/* Total Qty */}
                                    <col style={{ width: '6%' }} />   {/* Bundle */}
                                    <col style={{ width: '6%' }} />   {/* Pieces */}
                                    <col style={{ width: '8%' }} />   {/* Rate/Kg */}
                                    <col style={{ width: '7%' }} />   {/* Discount */}
                                    <col style={{ width: '8%' }} />   {/* Rate After Disc */}
                                    <col style={{ width: '9%' }} />   {/* Taxable Amt */}
                                    <col style={{ width: '6%' }} />   {/* GST% */}
                                    <col style={{ width: '8%' }} />   {/* GST ₹ */}
                                    <col style={{ width: '9%' }} />   {/* Total */}
                                    <col style={{ width: '5%' }} />   {/* Action */}
                                </colgroup>
                                <thead style={{ position: 'sticky', top: 0, zIndex: 2 }}>
                                    <tr style={{ backgroundColor: '#6b4c7a' }}>
                                        {[
                                            { label: 'Name', align: 'left' },
                                            { label: 'Qty', sub: 'No.Pieces', align: 'center' },
                                            { label: 'Total Qty', sub: 'Kgs', align: 'right' },
                                            { label: 'Bundle', align: 'center' },
                                            { label: 'Pieces', align: 'center' },
                                            { label: 'Rate/Kg', sub: 'Incl.Tax', align: 'right' },
                                            { label: 'Discount', align: 'right' },
                                            { label: 'Rate', sub: 'After Disc.', align: 'right' },
                                            { label: 'Taxable Amt', align: 'right' },
                                            { label: 'GST%', align: 'center' },
                                            { label: 'GST (₹)', align: 'right' },
                                            { label: 'Total', align: 'right' },
                                            { label: '', align: 'center' },
                                        ].map((col, i) => (
                                            <th key={i} style={{
                                                color: 'white',
                                                fontWeight: 700,
                                                fontSize: '11px',
                                                padding: '10px 8px',
                                                textAlign: col.align,
                                                whiteSpace: 'nowrap',
                                                borderRight: i < 12 ? '1px solid rgba(255,255,255,0.18)' : 'none',
                                                letterSpacing: '0.3px',
                                                lineHeight: '1.3',
                                            }}>
                                                {col.label}
                                                {col.sub && <><br /><span style={{ fontSize: '9px', fontWeight: 400, opacity: 0.85 }}>{col.sub}</span></>}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {itemList.filter(i => i.IsActive !== false).length === 0 ? (
                                        <tr>
                                            <td colSpan={13} style={{ textAlign: 'center', padding: '28px', color: '#aaa', fontSize: '13px', fontStyle: 'italic' }}>
                                                No items added yet. Select a product above and click Add Item.
                                            </td>
                                        </tr>
                                    ) : (
                                        itemList.map((invdetail, index) => {
                                            // Hide soft-deleted (IsActive: false) rows
                                            if (invdetail.IsActive === false) return null;

                                            const rateAfterDisc = (invdetail.discountPerPiece ?? 0) === 0
                                                ? invdetail.ratePerKg
                                                : (invdetail.ratePerKg - invdetail.discountPerPiece);
                                            const isAlt = index % 2 === 0;
                                            const rowBg = isAlt ? '#faf8fc' : '#ffffff';
                                            const inputStyle = {
                                                width: '100%',
                                                textAlign: 'right',
                                                padding: '4px 6px',
                                                fontSize: '11px',
                                                border: '1px solid #d0c4dc',
                                                borderRadius: '4px',
                                                backgroundColor: '#fff',
                                                outline: 'none',
                                                boxSizing: 'border-box',
                                            };
                                            return (
                                                <tr key={index} style={{ backgroundColor: rowBg, borderBottom: '1px solid #ede7f3', transition: 'background 0.15s' }}
                                                    onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f3edf8'}
                                                    onMouseLeave={e => e.currentTarget.style.backgroundColor = rowBg}
                                                >
                                                    {/* Name */}
                                                    <td style={{ fontSize: '12px', padding: '8px', fontWeight: 600, color: '#3d2459', borderRight: '1px solid #ede7f3', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                                                        title={invdetail.item}>
                                                        {invdetail.item}
                                                    </td>
                                                    {/* Qty */}
                                                    <td style={{ padding: '6px', borderRight: '1px solid #ede7f3' }}>
                                                        <input
                                                            type="number"
                                                            value={invdetail.quantity}
                                                            onChange={(e) => handleQuantityChange(e, index)}
                                                            min="0"
                                                            step="1"
                                                            style={inputStyle}
                                                        />
                                                    </td>
                                                    {/* Total Qty */}
                                                    <td style={{ fontSize: '11px', padding: '8px', textAlign: 'right', color: '#333', borderRight: '1px solid #ede7f3', fontVariantNumeric: 'tabular-nums' }}>
                                                        {Number(invdetail.totalQty || 0).toFixed(2)}
                                                    </td>
                                                    {/* Bundle */}
                                                    <td style={{ fontSize: '11px', padding: '8px', textAlign: 'center', color: '#555', borderRight: '1px solid #ede7f3' }}>
                                                        <span style={{ display: 'inline-block', background: '#ede7f3', borderRadius: '10px', padding: '1px 8px', fontWeight: 600 }}>
                                                            {invdetail.bundle ?? 0}
                                                        </span>
                                                    </td>
                                                    {/* Pieces */}
                                                    <td style={{ fontSize: '11px', padding: '8px', textAlign: 'center', color: '#555', borderRight: '1px solid #ede7f3' }}>
                                                        <span style={{ display: 'inline-block', background: '#e8f4fd', borderRadius: '10px', padding: '1px 8px', fontWeight: 600 }}>
                                                            {invdetail.pieces ?? 0}
                                                        </span>
                                                    </td>
                                                    {/* Rate/Kg */}
                                                    <td style={{ padding: '6px', borderRight: '1px solid #ede7f3' }}>
                                                        <input
                                                            type="number"
                                                            value={invdetail.ratePerKg}
                                                            onChange={(e) => handleRateChange(e, index)}
                                                            step="0.01"
                                                            min="0"
                                                            style={inputStyle}
                                                        />
                                                    </td>
                                                    {/* Discount */}
                                                    <td style={{ padding: '6px', borderRight: '1px solid #ede7f3' }}>
                                                        <input
                                                            type="number"
                                                            value={(isNaN(invdetail.discountPerPiece) || invdetail.discountPerPiece === "") ? '0' : invdetail.discountPerPiece}
                                                            onChange={(e) => handleDiscountChange(e, index)}
                                                            step="0.01"
                                                            min="0"
                                                            style={inputStyle}
                                                        />
                                                    </td>
                                                    {/* Rate After Discount */}
                                                    <td style={{ fontSize: '11px', padding: '8px', textAlign: 'right', color: '#1a7a4a', fontWeight: 600, borderRight: '1px solid #ede7f3', fontVariantNumeric: 'tabular-nums' }}>
                                                        {Number(rateAfterDisc || 0).toFixed(2)}
                                                    </td>
                                                    {/* Taxable Amt */}
                                                    <td style={{ fontSize: '11px', padding: '8px', textAlign: 'right', color: '#333', borderRight: '1px solid #ede7f3', fontVariantNumeric: 'tabular-nums' }}>
                                                        {invdetail.taxableAmt?.toFixed(2) ?? '0.00'}
                                                    </td>
                                                    {/* GST% */}
                                                    <td style={{ fontSize: '11px', padding: '8px', textAlign: 'center', color: '#555', borderRight: '1px solid #ede7f3' }}>
                                                        <span style={{ display: 'inline-block', background: '#fff8e1', color: '#b8860b', borderRadius: '10px', padding: '1px 7px', fontWeight: 600, fontSize: '10px' }}>
                                                            {invdetail.gstRate?.toFixed(2) ?? '0.00'}%
                                                        </span>
                                                    </td>
                                                    {/* GST ₹ */}
                                                    <td style={{ fontSize: '11px', padding: '8px', textAlign: 'right', color: '#c0392b', borderRight: '1px solid #ede7f3', fontVariantNumeric: 'tabular-nums' }}>
                                                        {invdetail.gstAmt?.toFixed(2) ?? '0.00'}
                                                    </td>
                                                    {/* Total */}
                                                    <td style={{ fontSize: '12px', padding: '8px', textAlign: 'right', fontWeight: 700, color: '#2c3e50', borderRight: '1px solid #ede7f3', fontVariantNumeric: 'tabular-nums' }}>
                                                        {invdetail.netAmt?.toFixed(2) ?? '0.00'}
                                                    </td>
                                                    {/* Delete */}
                                                    <td style={{ padding: '6px', textAlign: 'center' }}>
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => removeRecord(index)}
                                                            style={{ padding: '4px', color: '#e53935', backgroundColor: '#fdecea', borderRadius: '6px' }}
                                                        >
                                                            <DeleteIcon style={{ fontSize: '16px' }} />
                                                        </IconButton>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    )}
                                </tbody>
                                <tfoot>
                                    <tr style={{ backgroundColor: '#6b4c7a', color: 'white', fontWeight: 700 }}>
                                        <td style={{ fontSize: '12px', padding: '10px 8px', textAlign: 'left', borderRight: '1px solid rgba(255,255,255,0.2)', letterSpacing: '0.5px' }}>
                                            TOTAL
                                        </td>
                                        <td style={{ fontSize: '12px', padding: '10px 8px', textAlign: 'right', borderRight: '1px solid rgba(255,255,255,0.2)', fontVariantNumeric: 'tabular-nums' }}>
                                            {itemList.filter(i => i.IsActive !== false).reduce((acc, item) => acc + (Number(item.quantity) || 0), 0)}
                                        </td>
                                        <td style={{ fontSize: '12px', padding: '10px 8px', textAlign: 'right', borderRight: '1px solid rgba(255,255,255,0.2)', fontVariantNumeric: 'tabular-nums' }}>
                                            {itemList.filter(i => i.IsActive !== false).reduce((acc, item) => acc + (Number(item.totalQty) || 0), 0).toFixed(2)}
                                        </td>
                                        <td style={{ fontSize: '12px', padding: '10px 8px', textAlign: 'center', borderRight: '1px solid rgba(255,255,255,0.2)', fontVariantNumeric: 'tabular-nums' }}>
                                            {itemList.filter(i => i.IsActive !== false).reduce((acc, item) => acc + (Number(item.bundle) || 0), 0)}
                                        </td>
                                        <td style={{ fontSize: '12px', padding: '10px 8px', textAlign: 'center', borderRight: '1px solid rgba(255,255,255,0.2)', fontVariantNumeric: 'tabular-nums' }}>
                                            {itemList.filter(i => i.IsActive !== false).reduce((acc, item) => acc + (Number(item.pieces) || 0), 0)}
                                        </td>
                                        <td style={{ fontSize: '12px', padding: '10px 8px', textAlign: 'right', borderRight: '1px solid rgba(255,255,255,0.2)' }}>—</td>
                                        <td style={{ fontSize: '12px', padding: '10px 8px', textAlign: 'right', borderRight: '1px solid rgba(255,255,255,0.2)', fontVariantNumeric: 'tabular-nums' }}>
                                            {itemList.filter(i => i.IsActive !== false).reduce((acc, item) => acc + (Number(item.discountPerPiece) || 0), 0).toFixed(2)}
                                        </td>
                                        <td style={{ fontSize: '12px', padding: '10px 8px', textAlign: 'right', borderRight: '1px solid rgba(255,255,255,0.2)' }}>—</td>
                                        <td style={{ fontSize: '12px', padding: '10px 8px', textAlign: 'right', borderRight: '1px solid rgba(255,255,255,0.2)', fontVariantNumeric: 'tabular-nums' }}>
                                            {itemList.filter(i => i.IsActive !== false).reduce((acc, item) => acc + (Number(item.taxableAmt) || 0), 0).toFixed(2)}
                                        </td>
                                        <td style={{ fontSize: '12px', padding: '10px 8px', textAlign: 'center', borderRight: '1px solid rgba(255,255,255,0.2)' }}>—</td>
                                        <td style={{ fontSize: '12px', padding: '10px 8px', textAlign: 'right', borderRight: '1px solid rgba(255,255,255,0.2)', fontVariantNumeric: 'tabular-nums' }}>
                                            {itemList.filter(i => i.IsActive !== false).reduce((acc, item) => acc + (Number(item.gstAmt) || 0), 0).toFixed(2)}
                                        </td>
                                        <td style={{ fontSize: '13px', padding: '10px 8px', textAlign: 'right', borderRight: '1px solid rgba(255,255,255,0.2)', fontVariantNumeric: 'tabular-nums', backgroundColor: '#4a2d5a' }}>
                                            {itemList.filter(i => i.IsActive !== false).reduce((acc, item) => acc + (Number(item.netAmt) || 0), 0).toFixed(2)}
                                        </td>
                                        <td style={{ padding: '10px 8px' }}></td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>

                    {/* Delete Confirm Dialog */}
                    <Dialog
                        open={confirmDialogOpen}
                        onClose={closeConfirmDialog}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        PaperProps={{ style: { borderRadius: '12px', padding: '8px' } }}
                    >
                        <DialogTitle id="alert-dialog-title" style={{ color: '#6b4c7a', fontWeight: 700 }}>Delete Record?</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                ⚠️ Are you sure you want to delete <strong>"{itemnameget}"</strong> permanently?
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions style={{ padding: '8px 16px 16px' }}>
                            <button
                                onClick={closeConfirmDialog}
                                style={{ backgroundColor: '#dc3545', color: '#fff', border: 'none', borderRadius: '6px', padding: '8px 20px', cursor: 'pointer', fontWeight: 600 }}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleDelete}
                                style={{ backgroundColor: '#28a745', color: '#fff', border: 'none', borderRadius: '6px', padding: '8px 20px', cursor: 'pointer', fontWeight: 600, marginLeft: '8px' }}
                            >
                                Confirm
                            </button>
                        </DialogActions>
                    </Dialog>

                    </div> {/* end padding wrapper */}
                </form>
            </div>
        </div>
    );
};

export default AdditionalOrderEdit;
